<template>
  <div class="codes-view">
    <codes-form/>
  </div>
</template>

<script>
import CodesForm from '@/components/codes-form.vue'
/**
*
* CodesView Component
*
* @author Fernando Torres
* @copyright 2019, Marciano Studio S.C.
*/
export default {
  name: 'CodesView',
  components: {
    CodesForm
  }
}
</script>

<style lang='scss' scoped>
  .codes-view {
    // Content
  }
</style>



// WEBPACK FOOTER //
// src/views/app/children/codes.view.vue